
const digest = '98fa21aab63e2fc045de590f7a24049c4559b95c6f3e7d8e70daa9ed59b072f1';
const classes = {"wrapper":"_wrapper_1g5j2_1","bankIdIcon":"_bankIdIcon_1g5j2_10"};
const css = `._wrapper_1g5j2_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  margin-left: 10px;
}
._wrapper_1g5j2_1 ._bankIdIcon_1g5j2_10 {
  height: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  